export const faqData = [
  {
    id: 1,
    question: 'What platforms do you develop for?',
    answer:
      'I build Native Android apps using Kotlin and Jetpack Compose, and cross-platform apps using Flutter that run on both iOS and Android from a single codebase. For most startups, Flutter is the faster path to market. For apps that need deep Android-specific features, native Kotlin is the right call.',
  },
  {
    id: 2,
    question: 'How long does a typical app take to build?',
    answer:
      'A focused MVP with 3–5 core screens typically takes 2–4 weeks depending on the complexity of backend integrations. Apps with real-time features (chat, live data), AI API integrations, or complex state management take 4–8 weeks. I give a detailed timeline in the Scope of Work document before we begin — no surprises.',
  },
  {
    id: 3,
    question: 'Do you handle the backend too?',
    answer:
      'Yes — I work with Firebase (Auth, Firestore, Realtime DB) for most mobile projects, which covers 90% of what startups need. For more complex requirements, I can integrate PostgreSQL backends and REST APIs. If you need a heavy custom backend, I\'ll be transparent about scope and we can plan accordingly.',
  },
  {
    id: 4,
    question: 'What does your development process look like?',
    answer:
      'We start with a scoping call where I understand your requirements. I then send a written Scope of Work (SoW) with deliverables, milestones, and timeline. Development happens in weekly sprints with a demo at the end of each sprint so you\'re never left wondering what\'s happening. Final delivery includes source code, documentation, and a handover call.',
  },
  {
    id: 5,
    question: 'How do you price your work?',
    answer:
      "I price based on project scope and the business value the app delivers — not by the hour. This aligns my incentive with yours: I want to ship a product that actually works, not just log hours. Once I understand your requirements I'll send a fixed-price proposal so you know exactly what you're getting.",
  },
  {
    id: 6,
    question: 'How do we get started?',
    answer:
      "Fill out the contact form below or message me directly on LinkedIn. Tell me what you're building and what problem it solves. I'll respond within 24 hours with a few follow-up questions and we can schedule a scoping call from there. No commitment needed at that stage.",
  },
];
